{
  "account_is_inactive": "Your account is inactive.",
  "addons_email_marketing": "Email marketing",
  "addons_email_marketing_description": "Create newsletters, send targeted campaigns and track your results. Organize your contacts into lists and segments. Grow your audience with lead generation forms, and choose between hundreds of responsive themed templates.",
  "addons_email_marketing_lower": "<p>Subscribe now to:</p><ul><li><strong>Create</strong>, <strong>send</strong> and <strong>analyze targeted campaigns</strong></li><li>Organize your <strong>subscribers into lists</strong> and <strong>targeted segments</strong></li><li>Grow your audience with <strong>lead generation forms</strong>, <strong>pop-ups</strong> or <strong>inline forms</strong> on your website</li><li>Use more than <strong>700 free</strong>, ready-made, <strong>themed</strong> and <strong>responsive newsletter templates</strong></li><li>All in compliance with the <strong>CAN-SPAM Act</strong> and <strong>GDPR</strong></li></ul> <p><a href=\"https://emailchef.com/features/\" target=\"_blank\">Learn more</a> about our email marketing services.</p>",
  "addons_email_marketing_tryitforfree": "Start Your Free Trial",
  "addons_email_marketing_upper": "<p>Start creating email marketing campaigns with a professional and easy-to-use email marketing service. TurboSMTP's servers guarantee the <strong>best delivery rates</strong>.<p>",
  "addons_email_validator": "Email validator",
  "addons_email_validator_description": "Verify the accuracy and existence of the emails on your lists. Improve delivery rates and keep on using your IP shipping address.",
  "addons_emailmarketing_title": "Email marketing",
  "addons_title": "Addons",
  "analytics_average_click": "Average click delay",
  "analytics_average_click_description": "Average time elapsed between opening and clicking",
  "analytics_average_first": "Average first open delay",
  "analytics_average_first_description": "Average time elapsed between delivery and opening",
  "analytics_average_opens": "Average email open rate",
  "analytics_average_opens_description": "Average number of times an email was open.",
  "analytics_chart_frequency_d": "Daily",
  "analytics_chart_frequency_h": "Hourly",
  "analytics_chart_frequency_m": "Monthly",
  "analytics_chart_frequency_w": "Weekly",
  "analytics_charts": "Charts",
  "analytics_clicks_title": "No clicks",
  "analytics_date": "Date",
  "analytics_description_clicks_empty": "No data for clicks found.",
  "analytics_description_empty": "No data available for the selected period.",
  "analytics_event_bounce": "Bounced",
  "analytics_event_clicks": "Clicked",
  "analytics_event_delivered": "Delivered",
  "analytics_event_drop": "Dropped",
  "analytics_event_opens": "Opened",
  "analytics_event_queued": "Queued",
  "analytics_event_sent": "Delivered",
  "analytics_event_spam": "Spam",
  "analytics_event_unsubscribes": "Unsubscribed",
  "analytics_events": "Events",
  "analytics_events_all": "All",
  "analytics_events_bounce": "Bounced",
  "analytics_events_bounce_tooltip": "The percentage and number of emails rejected by your recipients' servers.",
  "analytics_events_bounces": "Bounced",
  "analytics_events_clicks": "Clicked",
  "analytics_events_clicks_tooltip": "The percentage and number of people who clicked at least one link in your message.",
  "analytics_events_delivered": "Delivered",
  "analytics_events_delivered_tooltip": "The percentage and number of sent messages successfully delivered.",
  "analytics_events_drop": "Dropped",
  "analytics_events_drop_tooltip": "These emails are excluded because they previously generated unsubscriptions, bounce, or spam reports. Dropped emails are listed in the \"Suppressions\" section.",
  "analytics_events_opens": "Opened",
  "analytics_events_opens_tooltip": "The percentage and number of emails opened by your recipients.",
  "analytics_events_queued": "Queue",
  "analytics_events_queued_tooltip": "The percentage of total emails still in the queue for sending.",
  "analytics_events_sent": "Delivered",
  "analytics_events_spam": "Spam",
  "analytics_events_spam_tooltip": "The percentage of recipients who reported your delivered message as spam.",
  "analytics_events_unsubscribes": "Unsubscribed",
  "analytics_events_unsubscribes_tooltip": "The percentage of unsubscribe requests resulting from successfully delivered emails.",
  "analytics_file": "File name",
  "analytics_filterby_domain": "Domain",
  "analytics_filterby_recipient": "Recipient",
  "analytics_filterby_sender": "Sender",
  "analytics_filterby_subject": "Subject",
  "analytics_filterby_x_campaign_id": "Header X-Campaign-ID",
  "analytics_numbers": "Numbers",
  "analytics_openclick": "Open/Click analytics",
  "analytics_overview": "Overview",
  "analytics_percentage": "Percentage",
  "analytics_reason": "Reason",
  "analytics_recipient": "Recipient",
  "analytics_sender": "Sender",
  "analytics_status": "Status",
  "analytics_subject": "Subject",
  "analytics_temporary_error": "A temporary error occurred. Please try again later.",
  "analytics_title": "Analytics",
  "analytics_topforopens": "Top for opens",
  "analytics_total_emails": "Uploaded emails",
  "analytics_total_processed": "Processed emails",
  "analytics_upload_date": "Upload date",
  "and": "and",
  "annually": "Annually",
  "authentication_expired": "Your session has expired. Please log in again.",
  "bcc_verification_code_invalid": "BCC verification code is invalid.",
  "bcc_verified": "BCC verified successfully",
  "billing_changepassword_description": "Change your password in this area. This password is used only to access the Dashboard.",
  "billing_changepassword_title": "Change password",
  "billing_contact_were_not_found": "Billing contact was not found.",
  "billing_contacts_address": "Address",
  "billing_contacts_address2": "Address 2",
  "billing_contacts_billing": "Invoice Emails - Invoices & Billing Reminders",
  "billing_contacts_button_add": "Add",
  "billing_contacts_button_edit": "Edit",
  "billing_contacts_city": "City",
  "billing_contacts_company": "Company name",
  "billing_contacts_country": "Country",
  "billing_contacts_domain_email": "Services",
  "billing_contacts_editcontact": "Edit Contact",
  "billing_contacts_email": "Email address",
  "billing_contacts_empty": "Email communications will be sent to the address in your main account. Enter more addresses to send communications to additional recipients.",
  "billing_contacts_firstname": "First name",
  "billing_contacts_general_email": "General",
  "billing_contacts_invoice_email": "Invoices",
  "billing_contacts_lastname": "Last name",
  "billing_contacts_marketing": "Service Emails - Renewal Notices, Registration Confirmations, etc.",
  "billing_contacts_phone": "Phone number",
  "billing_contacts_products": "Product Emails - Order Details, Welcome Emails, etc.",
  "billing_contacts_products_email": "Products",
  "billing_contacts_slide_description": "Email communications will be sent to the address in your main account. Enter more addresses to send communications to additional recipients.",
  "billing_contacts_slide_title": "Add New Contact",
  "billing_contacts_stateregion": "State/Region/Province",
  "billing_contacts_subscriptions": "Subscriptions",
  "billing_contacts_support": "Support Emails - Allow this user to open tickets in your account.",
  "billing_contacts_support_email": "Support",
  "billing_contacts_terms": "I have read and agree to the <a href=\"https://serversmtp.com/privacypolicy-eu-regulation-2016-79-gdpr/\" target=\"_blank\">Privacy Policy </a> and  <a href=\"https://serversmtp.com/terms-and-conditions/\" target=\"_blank\">Terms and Conditions</a>.",
  "billing_contacts_title": "Add Contacts",
  "billing_contacts_transactional": "General Emails - General Announcements & Password Reminders.",
  "billing_contacts_zip": "Zip code",
  "billing_details_contact_above": "Send only to the default contact",
  "billing_emails_sentdate": "Sent Date",
  "billing_emails_subject": "Subject",
  "billing_invoice_date": "Sent Date",
  "billing_invoice_duedate": "Due Date",
  "billing_invoice_number": "Number",
  "billing_invoice_status": "Status",
  "billing_invoice_status_cancelled": "Cancelled",
  "billing_invoice_status_paid": "Paid",
  "billing_invoice_status_refunded": "Refunded",
  "billing_invoice_status_unpaid": "Unpaid",
  "billing_invoice_total": "Total",
  "billing_product_payment_method_banktransfer": "Bank Transfer",
  "billing_product_paymentmethod_avangate": "Credit Card (Verizon former 2Checkout)",
  "billing_product_paymentmethod_stripe": "Credit Card (Stripe)",
  "button_add_contact": "Add Contact",
  "button_add_filter": "Add Filter",
  "button_add_plan": "Order a new plan",
  "button_add_sender": "Add Sender",
  "button_add_subaccount": "Add Sub-Account",
  "button_add_suppression": "Add Suppression",
  "button_add_template": "Add Template",
  "button_addbcc": "Add BCC",
  "button_addfooter": "Add Footer",
  "button_advanced_search": "Advanced search",
  "button_apply": "Apply",
  "button_back": "Back",
  "button_basic_search": "Basic search",
  "button_buycredits": "Buy Credits",
  "button_cancel": "Cancel",
  "button_close": "Close",
  "button_contact_us": "Contact us",
  "button_copy": "Copy",
  "button_create": "Create",
  "button_createalert": "Create Alert",
  "button_delete": "Delete",
  "button_delete_all": "Delete all",
  "button_delete_filtered": "Delete filtered",
  "button_delete_selected": "Delete selected ({n})",
  "button_edit": "Edit",
  "button_export": "Export",
  "button_import": "Import file",
  "button_limits": "Set Limits",
  "button_more": "More",
  "button_next": "Next",
  "button_open_ticket": "Open a new ticket",
  "button_pay": "Pay now",
  "button_refresh": "Refresh",
  "button_reload": "Reload",
  "button_request_cancellation": "Request Cancellation",
  "button_reset": "Reset",
  "button_returnlist": "Return to list",
  "button_save": "Save",
  "button_search": "Search",
  "button_select_fromdevice": "Select files from your device",
  "button_submit_ticket": "Submit Ticket",
  "button_unsubscribe": "Add Unsubscribe Link",
  "button_update": "Update",
  "button_update_template": "Update Template",
  "button_update_unsubscribe": "Update Unsubscribe Link",
  "button_updatealert": "Update Alert",
  "button_updatebcc": "Update BCC",
  "button_updatefooter": "Update Footer",
  "button_upgrade": "Upgrade",
  "button_upload": "Upload",
  "confirm_password_is_missing": "'Confirm password' is mandatory.",
  "dashboard_clicked": "Clicked",
  "dashboard_delivered": "Delivered",
  "dashboard_emails_sent": "total emails",
  "dashboard_emails_sent_out_of": "Emails sent out of",
  "dashboard_gotoanalytics": "Go to Analytics",
  "dashboard_new_version": "An updated version is available!",
  "dashboard_new_version_cancel": "OK",
  "dashboard_new_version_description": "Save your work first then reload the page,<br> or press \"Update now\" to load a new version.",
  "dashboard_new_version_ok": "Update now",
  "dashboard_plan_emails": "emails",
  "dashboard_plan_label": "Plan",
  "dashboard_plan_label_interval": "{interval} Plan",
  "dashboard_plan_limit_unit_daily": "day",
  "dashboard_plan_limit_unit_monthly": "month",
  "dashboard_plan_limit_unit_yearly": "year",
  "dashboard_recent_email_activities": "Recent email activities",
  "dashboard_try": "You are using a \"free trial\". To view the full dashboard:",
  "datepicker_last_3_months": "Last 3 months",
  "datepicker_last_30days": "Last 30 days",
  "datepicker_last_month": "Last month",
  "datepicker_last_sevendays": "Last 7 days",
  "datepicker_last_week": "Last week",
  "datepicker_last_year": "Last year",
  "datepicker_this_month": "This month",
  "datepicker_this_year": "This year",
  "datepicker_today": "Today",
  "datepicker_yesterday": "Yesterday",
  "delete_all_bounce": "Delete all bounces",
  "delete_all_manual": "Delete all manual",
  "delete_all_spam": "Delete all spam",
  "delete_all_unsubscribe": "Delete all unsubscriptions",
  "delete_fist_login_dont": "Don't show me this message again.",
  "delete_fist_login_one": "<h3>Welcome to the turboSMTP advanced dashboard.</h3><p>View real-time statistics about your email campaigns<br>and improve your results with professional tools.</p><h4><strong>Please follow the instructions to configure your clients.</strong></h4>",
  "delete_fist_login_three_a": "Please put the SMTP server name into your mail client.",
  "delete_fist_login_three_b": "<p><strong class=\"font-xxl\">pro.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_b_eu": "<p><strong class=\"font-xxl\">pro.eu.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_c": "Don't forget to configure your domain's DNS records <br>Find the parameters in your 'Settings'.",
  "delete_fist_login_two_a": "<h3>Open tracking</h3><p>lets turboSMTP track your messages' open rates.</p>",
  "delete_fist_login_two_b": "<h3>Click tracking</h3><p>lets turboSMTP track your messages' click rates.</p>",
  "first_login_apikey_description": "<h3>Generate Your API Key</h3><p>Create your default API key to start sending emails programmatically. This key will have SEND_SMTP and SEND_API permissions.</p>",
  "first_login_generate_apikey": "Generate API Key",
  "first_login_apikey_generated": "<h3>API Key Generated Successfully!</h3><p>Your API key has been created. Please save these credentials securely as the Consumer Secret will not be shown again.</p>",
  "first_login_apikey_warning": "<strong>Important:</strong> Save these credentials now. The Consumer Secret cannot be retrieved again.",
  "first_login_close_dont_show": "Close & Don't Show Again",
  "consumer_key": "Consumer Key",
  "consumer_secret": "Consumer Secret",
  "copied_to_clipboard": "Copied to clipboard",
  "copy_failed": "Failed to copy to clipboard",
  "display_auto_mode": "auto",
  "display_dark_mode": "dark",
  "display_font_size": "Font size",
  "display_large": "large",
  "display_layout_mode": "Layout mode",
  "display_light_mode": "light",
  "display_medium": "medium",
  "display_settings": "Display mode",
  "display_small": "small",
  "editor_quill_button_title": "Show HTML source",
  "editor_quill_cancel_text": "Cancel",
  "editor_quill_msg": "Edit the content in HTML format",
  "editor_quill_ok_text": "Ok",
  "emails_month": "emails/month",
  "emailvalidator_add_file": "Add file",
  "emailvalidator_add_form_errors": "Form errors",
  "emailvalidator_add_form_nofile_selected": "No file selected",
  "emailvalidator_add_value": "You can add between",
  "emailvalidator_attention": "Attention!",
  "emailvalidator_available": "free credits",
  "emailvalidator_balance_description": "Your credit balance is:",
  "emailvalidator_balance_title": "Your validation balance",
  "emailvalidator_buy_extra_credit": "Buy extra credit",
  "emailvalidator_complete": "Complete",
  "emailvalidator_confirm_delete_label": "Confirm action",
  "emailvalidator_confirm_delete_text": "Do you really want to delete this list?",
  "emailvalidator_contact_support": "<a class=\"p-button\" href=\"https://serversmtp.com/en/submitticket.php\" target=\"_blank\">Contact support <i class=\"ml-2 pi pi-external-link\"></i></a>",
  "emailvalidator_cost_per_email": "The cost per email is",
  "emailvalidator_date": "Creation date:",
  "emailvalidator_day": "Day",
  "emailvalidator_details_empty": "no elements inside",
  "emailvalidator_domain": "Domain",
  "emailvalidator_domain_age": "Domain age",
  "emailvalidator_email": "Email",
  "emailvalidator_email_addesses": "email addresses",
  "emailvalidator_empty": "An uploaded file must contain just one email address on each line. Allowed file formats are csv and txt. Or select a file to upload.",
  "emailvalidator_entry_details": "Validation Details",
  "emailvalidator_error": "Error",
  "emailvalidator_error_contact_support": "Error: contact support!",
  "emailvalidator_expiring": "expiring on",
  "emailvalidator_export": "Export",
  "emailvalidator_free_email": "Free email",
  "emailvalidator_how_many": "How many emails will you validate?",
  "emailvalidator_list_contains": "The uploaded list contains",
  "emailvalidator_list_not_removed": "Error removing the list",
  "emailvalidator_list_removed": "The List has been successfully removed.",
  "emailvalidator_mx_record": "MX record",
  "emailvalidator_please_enter_amout": "Please enter the amount you want to add to your virtual wallet.",
  "emailvalidator_price_calculator": "Price calculator",
  "emailvalidator_price_email": "Price per Email",
  "emailvalidator_process_now": "Process now",
  "emailvalidator_refresh": "refresh",
  "emailvalidator_slide_description": "The file must be one column containing all the email addresses you want to import.",
  "emailvalidator_slide_details_description": "Allowed file formats are csv or txt.",
  "emailvalidator_slide_details_title": "Drag and drop your file here.",
  "emailvalidator_slide_manually_description": "Copy and paste multiple or bulk email addresses in the area below, separated by an endline.",
  "emailvalidator_slide_manually_title": "Add Manually",
  "emailvalidator_slide_placeholder": "email1@yourdomain.com, email2@yourdomain.com",
  "emailvalidator_smpt_provider": "SMTP provider",
  "emailvalidator_status": "Status",
  "emailvalidator_status_abuse": "Abuse",
  "emailvalidator_status_catch_all": "Catch-all",
  "emailvalidator_status_do_not_mail": "Do not mail",
  "emailvalidator_status_invalid": "Invalid",
  "emailvalidator_status_spamtrap": "Spam",
  "emailvalidator_status_unknown": "Unknown",
  "emailvalidator_status_valid": "Valid",
  "emailvalidator_title": "Email Validator",
  "emailvalidator_total_cost": "The total cost is",
  "emailvalidator_upload_warning": "Your current credit balance is {current_balance} You need to purchase {needed_balance} of extra credit to validate this list.",
  "emailvalidator_validate_list": "Validate list",
  "emailvalidator_validate_freecredits_used": "The following free credits will be used:",
  "emailvalidator_validate_now": "Validate now",
  "emailvalidator_validated_lists": "Validated lists",
  "emailvalidator_validation_date": "Validation Date",
  "emailvalidator_value": "Value",
  "emailvalidator_you_have": "You have",
  "empty_authorization_token": "The authorization token is missing",
  "empty_request_body": "The request is incomplete",
  "error": "error",
  "file_too_large": "file_too_large",
  "filter": "Filter",
  "filter_by": "Filter by",
  "filter_fuzzy": "Smart search",
  "filter_fuzzy_description": "Enable this feature to return items similar to the search term.",
  "filter_placeholder_analytics": "Search...",
  "filter_placeholder_suppressions": "Search...",
  "filters_show": "Show filters",
  "filters_hide": "Hide filters",
  "filter_suppressions_placeholder": "Search by recipient, sender, email subject, or reason for suppression.",
  "first_login_step": "Step {n}",
  "forgot_password_changed": "Your password has been successfully changed.",
  "forgot_password_click": "Click here",
  "forgot_password_confirm": "Confirm your password",
  "forgot_password_done": "Done!",
  "forgot_password_donot_match": "Passwords do not match.",
  "forgot_password_email_not_found": "E-mail address not found",
  "forgot_password_enter_email": "Enter your email address",
  "forgot_password_error": "An error occurred while changing your password.",
  "forgot_password_expired": "The email to reset your password has expired.",
  "forgot_password_pick": "Pick a password",
  "forgot_password_please_reset": "Please set your password",
  "forgot_password_recovery_email_sent": "The recovery email has been sent",
  "forgot_password_resend": "to send the email again.",
  "forgot_password_reset": "Reset your password",
  "forgot_password_send_password_reset_link": "Send password reset link",
  "forgot_password_sent_email_to_update_password": "We've just sent you an email with a link to update your password.",
  "forgot_password_set": "Set your new password",
  "forgot_password_should_have": "Password should have",
  "forgot_password_suggestions": "<li>At least one lowercase</li> <li>At least one uppercase</li><li>At least one number</li><li>Minimum 10 characters</li>",
  "forgot_password_switch": "Switch to login",
  "forgot_password_switch_to_login": "Switch to login",
  "forgot_password_token_is_missing": "Forgot password token is missing",
  "forgot_password_unable_to_send": "Unable to send email.",
  "forgot_password_username": "Username email",
  "forgot_password_we_will_send_you": "We will send you a password recovery link.",
  "free_account": "Free Account",
  "friday": "Friday",
  "fuzzy_tooltip": "Enable this feature to return items similar to the search term",
  "goto_emailmarketing": "Go to email marketing",
  "goto_emailvalidator": "Go to email validator",
  "header_menu_support": "https://serversmtp.com/multilanguage-customer-support/",
  "internal_server_error_try_again": "Internal server error occurred. Please try again later.",
  "invalid_authorization_key": "Invalid authorization key is missing.",
  "invalid_authorization_token": "The authorization token is invalid",
  "invalid_limit_parameter_value_must_be_greater_than_or_equals_1": "The limit value must be at least 1",
  "invalid_page_parameter_value_must_be_greater_than_or_equals_1": "The page value must be at least 1",
  "invalid_value_for_orderby_parameter": "The 'order by' parameter is not valid.",
  "invalid_value_for_the_parameter_type": "Invalid value for the parameter type",
  "invoice_not_found": "Invoice not found",
  "jwt_error_full_details": "Full details",
  "jwt_error_status": "HTTP Status",
  "jwt_error_url": "URL",
  "jwt_url_not_exists": "The following URL doesn't exist",
  "l_allrights": "All rights reserved",
  "l_antispam_policy": "Anti-spam policy",
  "l_copyright": "© turboSMTP 2010 - ",
  "l_dont_have_account": "Don't have an account yet?",
  "l_email_address": "Email address",
  "l_forgot_password": "Forgot password?",
  "l_login": "Login",
  "l_password": "Password",
  "l_privacy_policy": "Privacy policy",
  "l_remember_me": "Keep me logged in.",
  "l_sign_up_here": "Sign up here",
  "l_tagline": "TurboSMTP - professional SMTP service provider",
  "l_username_email": "username email",
  "l_welcome_back": "Welcome Back",
  "language_changed_label": "You've changed the language ",
  "language_changed_message": "To apply language changes, reload the page",
  "language_changed_reload": "Reload",
  "m_accountinfo": "Account info",
  "m_addons": "Addons",
  "m_analytics": "Analytics",
  "m_billing": "Pro forma Invoices",
  "m_daily": "Daily",
  "m_dashboard": "Dashboard",
  "m_emailsentout": "emails sent out",
  "m_emailvalidator": "Email Validator",
  "m_home": "Home",
  "m_livechat": "Live chat",
  "m_messages": "System messages",
  "m_monthly": "Monthly",
  "m_myaccount": "My Account",
  "m_mydetails": "My Account",
  "m_noplans": "No Plans",
  "m_of": "of",
  "m_products": "My Products",
  "m_savechanges": "Save changes",
  "m_settings": "Settings",
  "m_subaccounts": "Sub Accounts",
  "m_suppressions": "Suppressions",
  "m_tickets": "My Tickets",
  "m_validuntil": "Valid until",
  "m_yearly": "Yearly",
  "missing_authorization_key": "Authorization key is missing.",
  "missing_or_invalid_value_provided_for_whiteLabeled_variable": "Valore mancante o non valido fornito per i record DNS (SPF e/o DKIM). Si prega di rivedere le impostazioni DNS.",
  "missing_required_parameter": "A required parameter is missing",
  "missing_required_parameter_email": "The email is missing",
  "missing_required_parameter_from": "The 'From' details are missing",
  "missing_required_parameter_to": "The 'to' details are missing",
  "missing_required_parameter_tz": "The 'tz' details are missing",
  "modal_confirmation": "Confirmation",
  "monday": "Monday",
  "monthly": "Monthly",
  "my_account_title": "My account",
  "myaccount_account_details": "My account",
  "myaccount_billing": "Pro forma Invoices",
  "myaccount_billing_cancellation_contact_support": "Contact Support",
  "myaccount_billing_cancellation_endofcycle_note": "Your subscription will remain active until the end of your current billing period, after which it will not renew.",
  "myaccount_billing_cancellation_proceed": "Proceed with Cancellation",
  "myaccount_billing_cancellation_reason": "Cancellation Reason",
  "myaccount_billing_cancellation_select_reason": "Select a reason",
  "myaccount_billing_cancellation_support_text": "Before you go, our support team may be able to help resolve your issue without cancelling. Would you like to reach out to us first?",
  "myaccount_billing_contacts": "Manage contacts",
  "myaccount_billing_contacts_description": "Email communications will be sent to the address in your main account. Enter more addresses to send communications to additional recipients.",
  "myaccount_billing_description": "In this section you can find the pro forma invoices issued before tax invoices. Tax invoices will be sent to you by email.",
  "myaccount_billing_details": "Account & Billing details",
  "myaccount_billing_details_address": "Address",
  "myaccount_billing_details_address2": "Address 2",
  "myaccount_billing_details_billing_company_name": "Billing company",
  "myaccount_billing_details_billing_contact": "Send pro forma invoices to an address other than the account address.",
  "myaccount_billing_details_billing_vat": "VAT / P.IVA / C.F. ",
  "myaccount_billing_details_billing_website": "Website",
  "myaccount_billing_details_city": "City",
  "myaccount_billing_details_country": "Country",
  "myaccount_billing_details_description": "Change your account details and billing address.",
  "myaccount_billing_details_details": "Billing details",
  "myaccount_billing_details_email": "Email address",
  "myaccount_billing_details_fistname": "First name",
  "myaccount_billing_details_lastname": "Last name",
  "myaccount_billing_details_marketing": "I want to receive dedicated offers and tips from turboSMTP",
  "myaccount_billing_details_phone_number": "Phone number",
  "myaccount_billing_details_policy": "I have read and agree to the <a href=\"https://serversmtp.com/privacypolicy-eu-regulation-2016-79-gdpr/\" target=\"_blank\">Privacy Policy</a> and  <a href=\"https://serversmtp.com/terms-and-conditions/\" target=\"_blank\">Terms and Conditions</a>.",
  "myaccount_billing_details_state": "State/Region",
  "myaccount_billing_details_zip": "Zip",
  "myaccount_billing_slides_description": "Here you can find the 'Pro forma invoices' related to your account.",
  "myaccount_billing_slides_nodata": "No Pro Forma Invoices were found",
  "myaccount_billingcontacts_added": "Billing contact added successfully",
  "myaccount_billingcontacts_deleted": "Billing contact deleted successfully",
  "myaccount_billingcontacts_edited": "Billing contact edited successfully",
  "myaccount_billingdetails_updated": "Billing details has been updated",
  "myaccount_change_password": "Change password",
  "myaccount_confirm_delete_selectedcontact_label": "Confirm action",
  "myaccount_confirm_delete_selectedcontact_text": "Do you really want to delete this contact?",
  "myaccount_confirm_password": "Confirm password",
  "myaccount_current_password": "Verify current password",
  "myaccount_delimiter_change": "Change CSV export delimiter",
  "myaccount_delimiter_select": "Select delimiter",
  "myaccount_language": "Display Language",
  "myaccount_language_change": "Change language",
  "myaccount_language_description": "TurboSMTP is available in the following languages: English, Italian and Spanish (French, German, Hebrew, Portuguese and Russian --- coming soon in beta version ---).",
  "myaccount_language_select": "Select language",
  "myaccount_localization": "Localization",
  "myaccount_localization_description": "Change language or CSV export delimiter.",
  "myaccount_messages": "System Messages",
  "myaccount_messages_nomessages": "No messages received",
  "myaccount_messages_nomessages_description": "This section you will find the messages that our system has sent to your account.",
  "myaccount_new_password": "New password",
  "myaccount_password_changed": "The password was changed successfully",
  "myaccount_password_choose": "Choose your new password",
  "myaccount_password_notmatch": "Those passwords didn't match. Try again.",
  "myaccount_password_suggestions": "Passwords should contain at least 10 characters, including both upper and lower case letters and at least one number.",
  "myaccount_2fa_title": "Two-Factor Authentication",
  "myaccount_2fa_description": "Enhance your account security by enabling two-factor authentication (2FA). This adds an extra layer of protection to your account.",
  "myaccount_2fa_card_description": "Enable two-factor authentication to protect your account.",
  "myaccount_2fa_select_method": "Select authentication method",
  "myaccount_2fa_method": "Authentication method",
  "myaccount_2fa_method_placeholder": "Choose an authentication method",
  "myaccount_2fa_otp_description": "Use an authenticator app (like Google Authenticator or Authy) to generate time-based codes.",
  "myaccount_2fa_email_description": "Receive verification codes via email.",
  "myaccount_2fa_sms_description": "Receive verification codes via SMS.",
  "myaccount_2fa_none_description": "Disable two-factor authentication for your account.",
  "myaccount_2fa_scan_qr": "Scan QR Code",
  "myaccount_2fa_scan_qr_description": "Scan this QR code with your authenticator app to set up two-factor authentication.",
  "myaccount_2fa_manual_entry": "Or enter this code manually:",
  "myaccount_2fa_copy_secret": "Copy to clipboard",
  "myaccount_2fa_secret_copied": "Secret key copied to clipboard",
  "myaccount_2fa_verify_code": "Verify Code",
  "myaccount_2fa_enter_code": "Enter verification code",
  "myaccount_2fa_code_placeholder": "000000",
  "myaccount_2fa_verify_code_description": "Enter the 6-digit code from your authenticator app to complete setup.",
  "myaccount_2fa_method_updated": "Two-factor authentication method updated successfully",
  "myaccount_2fa_otp_enabled": "Two-factor authentication enabled successfully",
  "myaccount_2fa_current_status": "Current status",
  "myaccount_2fa_status": "Two-Factor Authentication status",
  "myaccount_2fa_status_disabled": "Disabled",
  "myaccount_2fa_error_no_keycloak_id": "Unable to configure 2FA: user ID not found",
  "myaccount_2fa_error_invalid_code": "Invalid verification code. Please try again.",
  "myaccount_2fa_error_generic": "An error occurred while configuring two-factor authentication",
  "myaccount_2fa_enabled": "Enabled",
  "myaccount_2fa_disabled_label": "Disabled",
  "myaccount_2fa_disabled": "Two-factor authentication disabled successfully",
  "myaccount_product_delete_label": "Confirm action",
  "myaccount_product_delete_text": "Are you sure you want cancel this product?",
  "myaccount_product_deleted": "The cancellation request has been sent successfully.",
  "myaccount_products": "My products",
  "myaccount_products_billingcycle": "Billing Cycle",
  "myaccount_products_cycle_annually": "Annually",
  "myaccount_products_cycle_biennally": "Biennally",
  "myaccount_products_cycle_free_account": "Free Account",
  "myaccount_products_cycle_month": "Monthly",
  "myaccount_products_cycle_monthly": "Monthly",
  "myaccount_products_cycle_one_time": "One Time",
  "myaccount_products_cycle_onetime": "One Time",
  "myaccount_products_cycle_quarterly": "Quarterly",
  "myaccount_products_cycle_semi-annually": "Semi annually",
  "myaccount_products_cycle_triennially": "Triennially",
  "myaccount_products_cycle_year": "Yearly",
  "myaccount_products_cycle_yearly": "Yearly",
  "myaccount_products_fistpayment": "First Payment Amount",
  "myaccount_products_nextduedate": "Next Due Date",
  "myaccount_products_noproduct": "No product",
  "Sono nella sidebar di custom tracking domain": "In this section you will find the products and services associated with the account.",
  "myaccount_products_payment": "Payment Method",
  "myaccount_products_price": "Price",
  "myaccount_products_productservice": "Product/Service",
  "myaccount_products_recurringamount": "Recurring Amount",
  "myaccount_products_registration": "Registration Date",
  "myaccount_products_slide_productservice_description": "Manage your product directly from this area.",
  "myaccount_products_status": "Status",
  "plans_addon_options_title": "Add-on Plans",
  "plans_available_recurring_options_title": "Available Plans",
  "plans_billing_cycle": "Billing Cycle",
  "plans_current_plans_title": "Your Current Plans",
  "plans_cycle_month": "Monthly",
  "plans_cycle_monthly": "Monthly",
  "plans_cycle_onetime": "One-Time",
  "plans_cycle_year": "Yearly",
  "plans_cycle_yearly": "Yearly",
  "plans_downgrade_options_title": "Downgrade Options",
  "plans_feature_dedicated_ip": "Dedicated IP",
  "plans_feature_email_credits": "Email Credits",
  "plans_feature_smtp_limit": "SMTP Limit",
  "plans_features": "Features",
  "plans_invoice_created": "Invoice has been created successfully.",
  "plans_invoice_error": "Unable to create invoice. Please try again.",
  "plans_load_error": "Unable to load plan options. Please try again.",
  "plans_onetime_options_title": "One-Time Plans",
  "plans_plan_name": "Plan Name",
  "plans_plan_type": "Plan Type",
  "plans_select_plan": "Select Plan",
  "plans_type_addon": "Add-on",
  "plans_type_onetime": "One-Time",
  "plans_type_recurring": "Recurring",
  "plans_upgrade_options_title": "Upgrade Options",
  "myaccount_sentdate": "Sent date",
  "new_dashboard_error": "Sorry, an error occurred:",
  "new_dashboard_if_you_think": "If you think you are seeing this message in error, please <a href=\"https://serversmtp.com/contact-us/\" target=\"_blank\" >contact us</a>.",
  "new_dashboard_not_allowed": "Contact our <a href='https://serversmtp.com/contact-us/' target='_blank'>Support team</a> to start using the Beta Dashboard version.",
  "new_dashboard_token_valid": "Token is valid",
  "new_dashboard_token_wrong": "Token is wrong",
  "new_dashboard_validating": "Validating token...",
  "no": "No",
  "no_parameters_was_provided_for_update": "No parameter was provided for update",
  "no_suppression_data_were_provided": "No suppression data were provided",
  "one_time": "One Time",
  "optional": "Optional",
  "or": "or",
  "password_is_invalid": "No account matches that password",
  "password_is_missing": "Password is missing",
  "password_length_should_not_be_less_than_10_characters": "The password must contain at least 10 characters",
  "password_should_contain_at_least_one_uppercase_character": "The password must contain at least 1 uppercase character",
  "password_should_contain_at_least_one_lowercase_character": "The password must contain at least 1 lowercase character",
  "password_should_contain_at_least_one_digit": "The password must contain at least 1 digit",
  "password_should_equals_to_confirm_password": "Passwords mismatch. Enter same password twice in both fields.",
  "plan": "plan",
  "plan_daily": "Daily plan",
  "plan_desc": "{order}. {smtp_limit_interval} {planT} ({smtp_limit} / {limit_unit})",
  "plan_desc_small": "{smtp_limit} emails / {limit_unit}",
  "plan_monthly": "Monthly plan",
  "plan_short_daily": "day",
  "plan_short_monthly": "month",
  "plan_short_yearly": "year",
  "plan_yearly": "Yearly plan",
  "primeng": {
    "accept": "Yes",
    "addRule": "Add Rule",
    "after": "After",
    "apply": "Apply",
    "before": "Before",
    "cancel": "Cancel",
    "choose": "Choose",
    "clear": "Clear",
    "contains": "Contains",
    "dateAfter": "Date is after",
    "dateBefore": "Date is before",
    "dateFormat": "mm/dd/yy",
    "dateIs": "Date is",
    "dateIsNot": "Date is not",
    "dayNames": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "dayNamesMin": [
      "Su",
      "Mo",
      "Tu",
      "We",
      "Th",
      "Fr",
      "Sa"
    ],
    "dayNamesShort": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "emptyFilterMessage": "No results found",
    "emptyMessage": "No results found",
    "endsWith": "Ends with",
    "equals": "Equals",
    "firstDayOfWeek": 0,
    "gt": "Greater than",
    "gte": "Greater than or equal to",
    "is": "Is",
    "isNot": "Is not",
    "lt": "Less than",
    "lte": "Less than or equal to",
    "max_limit_reached": "You have reached the maximum number of subaccounts that can be activated on your current plan.",
    "matchAll": "Match All",
    "matchAny": "Match Any",
    "medium": "Medium",
    "monthNames": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "monthNamesShort": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "noFilter": "No Filter",
    "notContains": "Not contains",
    "notEquals": "Not equals",
    "passwordPrompt": "Enter a password",
    "reject": "No",
    "removeRule": "Remove Rule",
    "startsWith": "Starts with",
    "strong": "Strong",
    "today": "Today",
    "upload": "Upload",
    "weak": "Weak",
    "weekHeader": "Wk"
  },
  "return_toaddons": "Return to addons",
  "saturday": "Saturday",
  "server_error_please_try_again": "Server error. Please try again later.",
  "server_error_while_performing_update": "A server error occurred while performing update",
  "server_problem_gateway_timeout": "Server Gateway timeout, please retry.",
  "server_problem_please_retry": "Server problem, please retry.",
  "server_problem_unknown_error": "Unknown server error, please retry.",
  "settings_activities_description": "Receive account activity reports in your mailbox. Reports can be daily, weekly and/or monthly and cover all your account's activities.\n",
  "settings_activities_integrate": "Enable the \"Activity reports\" to receive reports for all your account's activities",
  "settings_activities_slide_dailyreport": "Daily Report",
  "settings_activities_slide_day": "Day",
  "settings_activities_slide_dayoftheweek": "Day of the week",
  "settings_activities_slide_description": "You can receive daily, weekly and monthly reports for all your account's activities. Your report will be sent to your registered email address.",
  "settings_activities_slide_monthlyreport": "Monthly Report",
  "settings_activities_slide_time": "Time",
  "settings_activities_slide_title": "Activity Reports",
  "settings_activities_slide_weeklyreport": "Weekly Report",
  "settings_activities_title": "Activity reports",
  "settings_alert_usage_limit": "Usage limit",
  "settings_alerts_description": "Receive an email alert when you have used a specific percentage of your email credits.",
  "settings_alerts_slide_add": "Add an Alert",
  "settings_alerts_slide_description": "To avoid running out of relays in the middle of a mailout, set an alert to be sent to your email address when you reach a set percentage of your credits. We suggest activating the alert at 80% of your available credit.",
  "settings_alerts_slide_empty_description": "Set an alert that will be delivered to your email address when you reach a set percentage of your credits.",
  "settings_alerts_slide_empty_title": "Add an Alert",
  "settings_alerts_slide_frequency": "Frequency",
  "settings_alerts_slide_percentage": "Percentage",
  "settings_alerts_slide_placeholder": "eg. name@addres.com",
  "settings_alerts_slide_sendto": "Send to",
  "settings_alerts_slide_title": "Alerts",
  "settings_alerts_slide_type": "Alert type",
  "settings_alerts_title": "Alerts",
  "settings_api_description": "Send your emails directly from your website or app with turboSMTP API.",
  "settings_api_title": "API documentation",
  "settings_bccs_description": "An email address added to the BCC list will receive a copy of every email sent without the recipient seeing the details of other recipients. ",
  "settings_bccs_enable": "Enable to authorize one email account to receive a copy of any sent emails",
  "settings_bccs_slide_add": "Add BCCs",
  "settings_bccs_slide_description": "Please set and authorize one or more email accounts to receive a copy of any sent emails.",
  "settings_bccs_slide_email": "Email",
  "settings_bccs_slide_empty": "Please set and authorize an email account that will receive a copy of any sent emails.",
  "settings_bccs_slide_empty_title": "Add a BCC Address",
  "settings_bccs_slide_name": "Name",
  "settings_bccs_slide_not_verified": "Not verified",
  "settings_bccs_slide_status": "Status",
  "settings_bccs_slide_title": "BCCs (Blind Carbon Copy)",
  "settings_bccs_slide_verified": "Verified",
  "settings_bccs_title": "BCCs (Blind Carbon Copy)",
  "settings_bounces_description": "Enabling Bounce Notifications sends notifications about your bounced emails to us. To receive all your bounce notifications yourself, disable this option.",
  "settings_bounces_slide_description": "settings_bounces_slide_description",
  "settings_bounces_slide_suppressbounce": "settings_bounces_slide_suppressbounce",
  "settings_bounces_slide_title": "Bounces Notifications",
  "settings_bounces_title": "Bounces Management",
  "settings_click_tracking": "Click Tracking",
  "settings_click_tracking_description": "Click Tracking records all the clicks made on each link in your emails.",
  "settings_dns_bar_description": "Both SPF and DKIM record should be added to all your sender email address domains.",
  "settings_dns_bar_dkim_description": "A DKIM record can be added as a TXT record by inserting the following:",
  "settings_dns_bar_dkim_domain": "Domain",
  "settings_dns_bar_dkim_title": "DKIM record",
  "settings_dns_bar_dkim_value": "Value",
  "settings_dns_bar_domainaut": "Domain Authentication",
  "settings_dns_bar_domainaut_description": "Allow turboSMTP to send emails on your behalf",
  "settings_dns_bar_domainaut_is": "The 'Domain Authentication' mode is:",
  "settings_dns_bar_spf_description": "Add the following TXT record to the domain of the envelope address (example.com), following one of two cases:",
  "settings_dns_bar_spf_description_a": "<strong>Should an SPF record already exist in your domain's DNS settings</strong>, you will need to modify it. Simply insert  ",
  "settings_dns_bar_spf_description_b": " directly after the segment ",
  "settings_dns_bar_spf_description_c": "Remember to leave a space before and after this addition to maintain proper syntax.",
  "settings_dns_bar_spf_description_d": "<strong>In the absence of an existing SPF</strong>, proceed to establish one by inputting the necessary information into a new TXT record within your DNS settings (no need to specify a SPF Domain unless required):",
  "settings_dns_bar_spf_title": "SPF record",
  "settings_dns_bar_title": "DNS Records",
  "settings_dns_description": "Add our DNS records to your domain to sign your emails with DKIM and ensure optimal deliverability.",
  "settings_dns_title": "DNS Records",
  "settings_email_body_tip": "Please specify <% body %> in your input.",
  "settings_email_elements": "Email elements",
  "settings_email_footers_added": "Footer added successfully",
  "settings_email_footers_confirm_delete_label": "Confirm action",
  "settings_email_footers_confirm_delete_text": "Do you really want to delete this footer?",
  "settings_email_footers_default": "Footer settings updated successfully",
  "settings_email_footers_removed": "Footer removed successfully",
  "settings_email_footers_updated": "Footer updated successfully",
  "settings_email_name_tip": "Please specify a name",
  "settings_email_templates_added": "Template added successfully",
  "settings_email_templates_confirm_delete_label": "Confirm action",
  "settings_email_templates_confirm_delete_text": "Do you really want to delete this template?",
  "settings_email_templates_default": "Templates settings updated successfully",
  "settings_email_templates_removed": "Template removed successfully",
  "settings_email_templates_updated": "Template updated successfully",
  "settings_email_unsub_added": "Unsubscribe link added successfully",
  "settings_email_unsub_confirm_delete_label": "Confirm action",
  "settings_email_unsub_confirm_delete_text": "Do you really want to delete this unsubscribe link?",
  "settings_email_unsub_removed": "Unsubscribe link removed successfully",
  "settings_email_unsub_updated": "Unsubscribe link updated successfully",
  "settings_footers_description": "Add a footer to your emails.",
  "settings_footers_enable": "Enable to add a footer to your emails",
  "settings_footers_slide_add": "Add footer",
  "settings_footers_slide_convert": "Convert to text",
  "settings_footers_slide_default": "Default",
  "settings_footers_slide_description": "Click \"Add Footer\" or edit an existing footer, filling the fields with the name of the footer, and using HTML or plain text.",
  "settings_footers_slide_empty_description": "Click \"Add Footer\" or edit an existing footer, filling the fields with the name of the footer, and using HTML or plain text.",
  "settings_footers_slide_empty_title": "No footers",
  "settings_footers_slide_htmltext": "HTML Text",
  "settings_footers_slide_name": "Name",
  "settings_footers_slide_plaintext": "Plain text",
  "settings_footers_slide_title": "Footers",
  "settings_footers_title": "Footers",
  "settings_ga_bar_description": "Please complete the following fields, including the name and source of your campaign data, to activate your Google Analytics integration.",
  "settings_ga_bar_title": "Google Analytics",
  "settings_ga_content": "Campaign content",
  "settings_ga_content_mandatory": "Campaign content is mandatory",
  "settings_ga_integrate": "Integrate Google Analytics to track your conversion rates and other data.",
  "settings_ga_medium": "Campaign medium",
  "settings_ga_medium_mandatory": "Campaign medium is mandatory",
  "settings_ga_name": "Campaign name",
  "settings_ga_name_mandatory": "Campaign name is mandatory",
  "settings_ga_parameters": "Parameters",
  "settings_ga_parameters_description": "Please complete the following fields, including the name and source of your campaign data, to activate your Google Analytics integration.",
  "settings_ga_source": "Campaign source",
  "settings_ga_source_mandatory": "Campaign source is mandatory",
  "settings_ga_term": "Campaign term",
  "settings_ga_term_mandatory": "Campaign term is mandatory",
  "settings_google_analytics_description": "Google Analytics tracks your conversion rates and other data.",
  "settings_google_analytics_title": "Google Analytics",
  "settings_integrations": "Integrations",
  "settings_integrations_authentication_disabled": "Domain authentication is: Disabled",
  "settings_integrations_authentication_enabled": "Domain authentication is: Enabled",
  "settings_integrations_dkim_updated": "DKIM settings updated successfully",
  "settings_notification_alert_confirm_delete_label": "Confirm action",
  "settings_notification_alert_confirm_delete_text": "Do you really want to delete this alert?",
  "settings_notification_bcc_confirm_delete_label": "Confirm action",
  "settings_notification_bcc_confirm_delete_success": "The BCC {email} was deleted successfully.",
  "settings_notification_bcc_confirm_delete_text": "Do you really want to delete this BCC {email}?",
  "settings_notification_smtp_auth": "SMTP Authentication",
  "settings_notifications": "Notifications",
  "settings_notifications_alert_added": "The Alert is created successfully",
  "settings_notifications_alert_deleted": "The Alert deleted successfully.",
  "settings_notifications_alert_updated": "The Alert is updated successfully",
  "settings_notifications_bcc_emailbox": "We have just sent a verification message to <{email}>. ",
  "settings_notifications_bcc_update_success": "The BCC {email} has been updated successfully.",
  "settings_notifications_smtp_auth_enabled": "Enabled",
  "settings_notifications_smtp_host": "pro.turbo-smtp.com",
  "settings_notifications_smtp_host_eu": "pro.eu.turbo-smtp.com",
  "settings_notifications_smtp_passvalue": "*********<br>(the password you use to enter this dashboard)",
  "settings_notifications_smtp_password": "SMTP Password",
  "settings_notifications_smtp_ports": "SMTP Ports",
  "settings_notifications_smtp_server": "SMTP Server",
  "settings_notifications_smtp_username": "SMTP Username",
  "settings_open_tracking": "Open Tracking",
  "settings_open_tracking_description": "Enabling Open Tracking will create a record of your open messages, enabling you to better track campaign results.",
  "settings_senders_description": "Add your senders here",
  "settings_senders_domains": "Senders & domains",
  "settings_senders_title": "Authenticated Senders",
  "settings_setting_google_changed": "Google analytics settings are changed.",
  "settings_setting_webhooks_changed": "Webhooks settings are changed.",
  "settings_setting_activity_reports_changed": "Activity reports are changed.",
  "settings_setting_bccs_disabled": "BCC is disabled now.",
  "settings_setting_bccs_enabled": "BCC is enabled now.",
  "settings_setting_post_smtp_bounce_disabled": "Bounce management is now disabled",
  "settings_setting_post_smtp_bounce_enabled": "Bounce management is now enabled",
  "settings_setting_periodicreport_disabled": "Perodic reports are now disabled",
  "settings_setting_periodicreport_enabled": "Perodic reports are now enabled",
  "settings_setting_webhook_disabled": "Webhooks are now disabled",
  "settings_setting_webhook_enabled": "Webhooks are now enabled",
  "settings_setting_unsubscribelinks_disabled": "Unsubscribe link is now disabled",
  "settings_setting_unsubscribelinks_enabled": "Unsubscribe link is now enabled",
  "settings_setting_footers_disabled": "Footer is now disabled",
  "settings_setting_footers_enabled": "Footer is now enabled",
  "settings_setting_templates_disabled": "Template is now disabled",
  "settings_setting_templates_enabled": "Template is now enabled",
  "settings_setting_openingtracking_disabled": "Open tracking is now disabled",
  "settings_setting_openingtracking_enabled": "Open tracking is now enabled",
  "settings_setting_clicktracking_disabled": "Click tracking is now disabled",
  "settings_setting_clicktracking_enabled": "Click tracking is now enabled",
  "settings_setting_google_disabled": "Google analytics is now disabled",
  "settings_setting_google_enabled": "Google analytics is now enabled",
  "settings_setting_link_branding_disabled": "Custom tracking domains are now disabled",
  "settings_setting_link_branding_enabled": "Custom tracking domains are now enabled",
  "settings_setting_notdisabled": "Setting {service} cannot be disabled",
  "settings_setting_notenabled": "Setting {service} cannot be enabled",
  "settings_setting_webhook_notenabled": "Event Notification Web-hooks are available on PRO recurring plans only.",
  "settings_smtp_description": "To connect via SMTP, configure SMTP in your mail client or in any other mailing app by adding the following parameters. Click the \"More\" button to see the parameters.",
  "settings_smtp_slide_description": "Configure SMTP in your mail client, or in any other mailing app, by adding the following parameters.",
  "settings_smtp_slide_description_api": "The SMTP authentication username and password are an API keys pair: use the Consumer Key as the SMTP username and the Consumer Secret as the SMTP password. Treat them as credentials that must be kept secret and rotated if needed.",
  "settings_smtp_slide_parameter": "Parameter",
  "settings_smtp_slide_title": "Connecting via SMTP",
  "settings_smtp_slide_value": "Value",
  "settings_smtp_title": "Connecting via SMTP",
  "settings_template_description": "Templates are the perfect tool to easily give your email an effective layout.",
  "settings_template_enable": "Enable to style your emails with the default template",
  "settings_template_slide_add": "Add template",
  "settings_template_slide_default": "Default",
  "settings_template_slide_description": "Templates are the perfect tool to easily give your email an effective layout.",
  "settings_template_slide_empty_description": "Click \"Add Template\" and complete the fields with the required information, including the name of the template, and HTML or plain text.",
  "settings_template_slide_empty_title": "Add a template",
  "settings_template_slide_html": "HTML version",
  "settings_template_slide_info": "<% body %> is compulsory in HTML text and plain text. The placeholder will be replaced with real content.",
  "settings_template_slide_name": "Template name",
  "settings_template_slide_plaintext": "Plain text version",
  "settings_template_slide_title": "Templates",
  "settings_template_title": "Templates",
  "settings_title": "Settings",
  "settings_tracking": "Tracking",
  "settings_unsubscribe_description": "Add an unsubscribe link to the bottom of text and HTML emails. No emails will be delivered to unsubscribed users.",
  "settings_unsubscribe_enable": "Enable to add an unsubscribe link to your emails",
  "settings_unsubscribe_select": "Select a language",
  "settings_unsubscribe_slide_add": "Add unsubscribe link",
  "settings_unsubscribe_slide_description": "Add an unsubscribe link to the bottom of text and HTML emails. No emails will be delivered to unsubscribed users. Subscription cancellations will be handled automatically and in real time to improve your mailing reputation. Enter the text you want to use (such as \"To unsubscribe, click here\") then paste the text into the placeholder in your message.",
  "settings_unsubscribe_slide_empty": "Add an unsubscribe link",
  "settings_unsubscribe_slide_empty_description": "Add an unsubscribe link to the bottom of text and HTML emails. No emails will be delivered to unsubscribed users. Subscription cancellations will be handled automatically and in real time to improve your mailing reputation.",
  "settings_unsubscribe_slide_language": "Select a language",
  "settings_unsubscribe_slide_placeholder": "Placeholder",
  "settings_unsubscribe_slide_text": "Unsubscribe text",
  "settings_unsubscribe_slide_title": "Unsubscribe link",
  "settings_unsubscribe_text": "Text",
  "settings_unsubscribe_title": "Unsubscribe link",
  "settings_unsubscribe_value": "Eg: To unsubscribe, click here",
  "settings_webhooks_description": "Webhooks allow your web application to receive a notification of email delivery and interaction events.",
  "settings_webhooks_slide_alert": "Any changes applied may take up to 1 hour to take effect.",
  "settings_webhooks_slide_bounced": "Bounced",
  "settings_webhooks_slide_click": "Click",
  "settings_webhooks_slide_deferred": "Deferred",
  "settings_webhooks_slide_delivered": "Delivered",
  "settings_webhooks_slide_deliveryevents": "Delivery Events",
  "settings_webhooks_slide_description": "You can use Event Notification Webhooks to be notified of events that happen in your email project without using APIs.",
  "settings_webhooks_slide_dropped": "Dropped",
  "settings_webhooks_slide_engagementevents": "Engagement Events",
  "settings_webhooks_slide_inserturl": "Insert here the url you want to be notified:",
  "settings_webhooks_slide_notification": "Webhook notification Url",
  "settings_webhooks_slide_notification_description": "Enable web-hook notifications",
  "settings_webhooks_slide_open": "Open",
  "settings_webhooks_slide_placeholder": "https://",
  "settings_webhooks_slide_processed": "Processed",
  "settings_webhooks_slide_spamreport": "Spam report",
  "settings_webhooks_slide_title": "Webhooks",
  "settings_webhooks_slide_unsubscribe": "Unsubscribe",
  "settings_webhooks_support": "Please contact support and ask for 'Delivery Events Activation'.",
  "settings_webhooks_title": "Webhooks",
  "settings_webhooks_upgrade": "Upgrade now",
  "status_active": "Active",
  "status_inactive": "Inactive",
  "status_cancelled": "Cancelled",
  "status_fraud": "Fraud",
  "status_pending": "Pending",
  "status_suspended": "Suspended",
  "status_terminated": "Terminated",
  "subaccount_policy_agree": "I have read and agree the <a href=\"https://serversmtp.com/privacypolicy-eu-regulation-2016-79-gdpr/\" target=\"_blank\">Privacy Policy </a> and  <a href=\"https://serversmtp.com/terms-and-conditions/\" target=\"_blank\">Terms and Conditions</a>",
  "subaccount_policy_agree_notchecked": "You must agree to the terms of service and privacy policy.",
  "subaccount_slide_inuse": "In use",
  "subaccount_slide_ip": "IP",
  "subaccount_slide_ips": "IPs",
  "subaccount_slide_ips_description": "Please, select an IP to assign to this sub account.",
  "subaccount_slide_selectplan": "Select a plan",
  "subaccount_slide_spf": "SPF Record",
  "subaccounts_action_activated": "{email} has been successfully activated",
  "subaccounts_action_active": "Active",
  "subaccounts_action_deactivated": "{email} has been successfully suspended",
  "subaccounts_action_delete": "Delete",
  "subaccounts_action_deleted": "Subaccount deleted successfully",
  "subaccounts_action_details": "Details",
  "subaccounts_action_edit": "Edit",
  "subaccounts_action_limit": "Set limits",
  "subaccounts_action_login": "Login",
  "subaccounts_action_notdeleted": "Error deleting subaccount",
  "subaccounts_action_suspend": "Suspend",
  "subaccounts_active": "Active",
  "subaccounts_added_succesfully": "The sub-account was added successfully",
  "subaccounts_agencysettings": "Agency settings",
  "subaccounts_assigned_ip": "Assigned IP",
  "subaccounts_changed_succesfully": "The sub-account was changed successfully",
  "subaccounts_confirm_activation_label": "Confirm activation",
  "subaccounts_confirm_activation_text": "Do you want activate {email}?",
  "subaccounts_confirm_deactivation_label": "Confirm deactivation",
  "subaccounts_confirm_deactivation_text": "Do you want to suspend the sub account: {email}?",
  "subaccounts_confirm_delete_label": "Confirm deletion",
  "subaccounts_confirm_delete_text": "Do you want delete the subaccount {email}?",
  "subaccounts_confirm_login_label": "Confirm login",
  "subaccounts_confirm_login_text": "Are you sure you want to log out of the current account and log in to {email}?",
  "subaccounts_confirmation": "Confirmation",
  "subaccounts_create_warning": "Hey there! It looks like subaccounts aren't included in your current plan. If you're interested in adding them, our support team would be happy to help you explore your options!",
  "subaccounts_create_limit_warning": "Almost there! You've hit the maximum number of subaccounts for your current plan. Contact support to explore upgrade options and keep growing!.",
  "subaccounts_upgrade_button": "Upgrade now",
  "subaccounts_email": "Account email",
  "subaccounts_empty": "Enlarge your business and offer your customers a professional service fully customizable with your brand, or divide your emails between your employees and colleagues.<br>A simple management interface will allow you to monitor traffic and statistics.",
  "subaccounts_expiration_date": "Expiration date",
  "subaccounts_filter_ip": "Filter by IP...",
  "subaccounts_filter_status": "Filter by Status...",
  "subaccounts_filters_no_results": "No entries were found with these filters",
  "subaccounts_inactive": "Inactive",
  "subaccounts_ip": "IP",
  "subaccounts_last_activity": "Last activity",
  "subaccounts_limits_nolimits": "No limits",
  "subaccounts_limits_sending": "Sending limit:",
  "subaccounts_limits_slide_description": "Set a limit for your sub account.",
  "subaccounts_limits_slide_limits": "Limits",
  "subaccounts_limits_slide_noplan_expiration": "No expiration",
  "subaccounts_limits_slide_plan_expiration": "Plan expiration",
  "subaccounts_limits_slide_set_plan_expiration": "Set plan expiration:",
  "subaccounts_limits_slide_this_number": "This number refers to a period",
  "subaccounts_limits_slide_title": "Sub account limits",
  "subaccounts_logo_changed_success": "Agency logo successfully updated",
  "subaccounts_logo_changed_error": "Error attempting to update agency logo",
  "subaccounts_logo_reset_success": "Default logo successfully restored",
  "subaccounts_logo_reset_error": "Error attempting to restore default logo",
  "subaccounts_no_expiration": "{master_expiration_date} <i class='pi pi-info-circle'></i>",
  "subaccounts_no_expiration_tooltip": "According to main account plan expiration",
  "subaccounts_search_placeholder": "Filter by email...",
  "subaccounts_settings_update": "Sub-account settings are updated now.",
  "subaccounts_slide_account_confirm": "Confirm account details",
  "subaccounts_slide_account_description": "Click the Edit button to change your sub account user information.",
  "subaccounts_slide_account_info": "Account information",
  "subaccounts_slide_address": "Address",
  "subaccounts_slide_address2": "Address 2",
  "subaccounts_slide_change_password": "Set a Password",
  "subaccounts_slide_city": "City",
  "subaccounts_slide_company": "Company name",
  "subaccounts_slide_confirm_password": "Confirm password",
  "subaccounts_slide_confirmpassword_different": "Please make sure that your passwords match.",
  "subaccounts_slide_country": "Country",
  "subaccounts_slide_email": "Email address",
  "subaccounts_slide_email_not_unique": "This email cannot be used, it may be invalid or it may already be in use.",
  "subaccounts_slide_email_required": "An email address is required.",
  "subaccounts_slide_first_name": "First name",
  "subaccounts_slide_firstname_required": "First name is required.",
  "subaccounts_slide_last_name": "Last name",
  "subaccounts_slide_lastname_required": "Last name is required.",
  "subaccounts_slide_password": "Password",
  "subaccounts_slide_password_details": "Leave the password field blank to continue using your current password.",
  "subaccounts_slide_password_minlength": "The password length should be at least {req}. It's currently: {act}.",
  "subaccounts_slide_password_required": "Password is required.",
  "subaccounts_slide_password_pattern": "The password must contain at least 10 characters, one uppercase, one lowercase and one digit",
  "subaccounts_slide_phone": "Phone",
  "subaccounts_slide_profile_information": "Profile information",
  "subaccounts_slide_region": "State/Region/Province",
  "subaccounts_slide_website": "Website",
  "subaccounts_slide_zip": "Zip",
  "subaccounts_status": "Status",
  "subaccounts_subaccounts": "Sub accounts list",
  "subaccounts_title": "Sub-accounts",
  "subaccounts_unlimited": "Unlimited <i class='pi pi-info-circle'></i>",
  "subaccounts_unlimited_tooltip": "According to main account plan limit.",
  "subaccounts_usage": "Usage",
  "ip_not_associated_to_user_account": "IP was not associated to subaccount.",
  "sunday": "Sunday",
  "suppression_deleted": "Suppressions will be deleted shortly.",
  "suppression_filters_reason": "Reason",
  "suppression_filters_recipient": "Recipient",
  "suppression_filters_sender": "Sender",
  "suppression_filters_sources": "Sources",
  "suppression_filters_subject": "Email subject",
  "suppression_operators_exclude": "Exclude",
  "suppression_operators_include": "Include",
  "suppression_table_addcolumn_sender": "Sender",
  "suppression_table_dropdown_text": "{first} — {last} of {totalRecords}",
  "suppression_types_bounce": "Bounced",
  "suppression_types_manual": "Manual",
  "suppression_types_spam": "Spam",
  "suppression_types_unsubscribe": "Unsubscribed",
  "suppression_types_validation_failed": "Validation failed",
  "suppressions_add_form_errors": "Form errors",
  "suppressions_add_form_nofile_selected": "No file selected",
  "suppressions_add_suppression": "Import suppressions",
  "suppressions_choose_columns": "Choose colums",
  "suppressions_confirm_delete_all_label": "Confirm action",
  "suppressions_confirm_delete_all_text": "Do you really want to delete all suppressions between <strong>{from}</strong> and <strong>{to}</strong>?",
  "suppressions_confirm_delete_all_type_text": "Do you really want to delete<br> all <strong>{type}</strong> suppressions between <strong>{from}</strong> and <strong>{to}</strong>?",
  "suppressions_confirm_delete_filtered_label": "Confirm action",
  "suppressions_confirm_delete_filtered_text": "Do you really want to delete all <strong>suppressions filtered</strong>?<br><small>*Spam entries will not be deleted.</small>",
  "suppressions_confirm_delete_selected_label": "Confirm action",
  "suppressions_confirm_delete_selected_text": "Do you really want to delete the selected suppressions?",
  "suppressions_date": "Date",
  "suppressions_delete_all": "Delete all",
  "suppressions_delete_selected": "Delete the selection",
  "suppressions_deleted": "Suppressions will be deleted shortly.",
  "suppressions_description": "A suppression is an email address or domain that is blocked from receiving further emails. Email addresses on this page are past hard bounces (from the past 7 days), spam complaints, unsubscribes, manual entries, and any added by compliance.",
  "suppressions_description_empty": "No entries were found for the selection period.",
  "suppressions_details_date": "Date",
  "suppressions_details_entry": "Entry",
  "suppressions_details_reason": "Reason",
  "suppressions_details_sender": "Sender",
  "suppressions_details_subject": "Subject",
  "suppressions_details_title": "Suppression detail",
  "suppressions_details_type": "Type",
  "suppressions_event_history": "Event History",
  "suppressions_imported": "Your suppressions will soon be imported.",
  "suppressions_imported_partial": "{imported} / {total} suppressions will soon be imported.",
  "suppressions_include": "Include",
  "suppressions_modal_confirm": "Confirmation",
  "suppressions_not_imported": "Suppressions won't be imported due to malformed emails.",
  "suppressions_reason": "Reason",
  "suppressions_recipient": "Recipient",
  "suppressions_subject": "Subject",
  "suppressions_title": "Suppressions",
  "suppressions_title_empty": "No suppressions found",
  "suppressions_type": "Type",
  "t_api": "API documentation",
  "t_knowledgebase": "Knowledge base",
  "t_logout": "Logout",
  "t_newsupdates": "News & Updates",
  "t_search": "Search",
  "t_support": "Support",
  "t_username": "Username",
  "table_dropdown_goto": "Go to page",
  "table_dropdown_text": "{first} — {last} of {totalRecords}",
  "thursday": "Thursday",
  "tickets_description_empty": "The support ticket system allows us to respond to your problems and enquiries as quickly as possible. When we make a response to your support ticket, you will be notified via email.",
  "tickets_title_empty": "Open a new support ticket",
  "toggle_off": "Disabled",
  "toggle_on": "Enabled",
  "token_can_not_be_empty": "The token cannot be empty",
  "token_is_missing": "The token is missing",
  "tuesday": "Tuesday",
  "unlimited": "Unlimited",
  "upload_add_manually": "Add Manually",
  "upload_add_manually_description": "Copy and paste multiple or bulk email addresses in the area below, separated by an endline. To remember why you added the contacts and to help future searches, add a reason for  suppressing these addresses.",
  "upload_add_reason": "Enter a reason for suppressing these addresses",
  "upload_allowed_files": "Allowed file formats are csv or txt.",
  "upload_dd_here": "Drag and drop your file here",
  "upload_formats": "Upload formats",
  "upload_import_from_file": "Import from a file",
  "upload_import_from_file_description": "The file must be one column containing all the email addresses you want to import. To remember why you added the contacts and to help future searches, add a reason for  suppressing these addresses.",
  "warning_lang": "",
  "wednesday": "Wednesday",
  "whitelabel_agencyname": "Agency name",
  "whitelabel_companydetails": "Company details",
  "whitelabel_description": "If you have opened a sub account and are an official turboSMTP reseller, customizing the product with your logo and company information will give customers your brand experience.",
  "whitelabel_footer": "Agency footer",
  "whitelabel_footer_description": "Insert the HTML code to be displayed on the footer page.",
  "whitelabel_logo": "Company logo",
  "whitelabel_logo_description": "Maximum image size allowed: 472x72px",
  "whitelabel_reset_default_image": "Restore default image",
  "whitelabel_upload_image": "Upload image",
  "whitelabel_upload_in_progress": "Upload in progress",
  "whitelabel_website": "Agency website",
  "wrong_credentials_specified": "The specified credentials are wrong.",
  "yes": "Yes",
  "missing_required_parameter_amount": "The amount is missing",
  "amount_should_be_integer": "The amount should be a whole number",
  "amount_should_not_be_less_than_15": "The amount shouldn't be less than 15",
  "amount_should_not_be_higher_than_1800": "The amount shouldn't be more than 1800",
  "missing_settings_required": "Some settings are required before enabled it",
  "settings_apikeys_title": "API Keys",
  "settings_apikeys_description": "API Keys are a highly secure way to connect turboSMTP services to your applications. You can revoke access at any time.",
  "settings_apikeys_slide_title": "API Keys",
  "settings_apikeys_slide_description": "Manage your API Keys. This table shows all your active API Keys. You can create new keys or delete existing keys to revoke their access.",
  "settings_apikeys_slide_empty_title": "Create API Key",
  "settings_apikeys_slide_empty_description": "API Keys consist of Consumer Keys and Consumer Secret. They're software credentials that allow a program to access your turboSMTP account without using your username and password. They're highly secure and can be revoked at any time without changing your turboSMTP dashboard credentials.",
  "settings_apikeys_slide_add": "Create API Key",
  "settings_apikeys_slide_add_description": "Choose a reference name for your API Key.",
  "settings_apikeys_apikey_name": "Name",
  "settings_apikeys_slide_label_info": "This name is for reference only. You won't need to enter the name in your apps.",
  "settings_apikeys_apikey_key": "Consumer Key",
  "settings_apikeys_apikey_creationtime": "Creation time",
  "settings_apikeys_apikey_name_label": "API Key name",
  "settings_apikeys_apikey_name_placeholder": "Set your API Key name",
  "settings_apikeys_apikey_edit_alt": "Edit API Key",
  "settings_apikeys_apikey_revoke_alt": "Delete & revoke",
  "settings_apikeys_apikey_confirm_revoke_label": "Delete & revoke API Key",
  "settings_apikeys_apikey_confirm_revoke_text": "Delete API Key \"{name}\"?<br>This will revoke access for all apps that use this key.",
  "settings_apikeys_apikey_confirm_revoke_confirm": "Confirm",
  "settings_apikeys_apikey_confirm_revoke_cancel": "Cancel",
  "settings_apikeys_apikey_revoked": "API Key revoked successfully",
  "settings_apikeys_apikey_consumerkey_button_add": "Generate API Key",
  "settings_apikeys_apikey_consumerkey_button_save": "Save Changes",
  "settings_apikeys_slide_edit_description": "Edit the API Key details below.",
  "settings_apikeys_apikey_updated": "API Key updated successfully",
  "settings_apikeys_apikey_new_success": "API Key Created!",
  "settings_apikeys_apikey_consumer": "Consumer Key",
  "settings_apikeys_apikey_secret": "Consumer Secret",
  "settings_apikeys_apikey_new_security": "This <strong>Consumer Secret</strong> is only displayed here. <strong>Copy it now and keep it safe</strong>. If you lose this key, you'll need to delete it and generate a new one",
  "settings_apikeys_ips_label": "IPs restriction",
  "settings_apikeys_restrict_ip_label": "Restrict API Key to specific IPs",
  "settings_apikeys_restrict_ip_description": "When enabled, this API Key will only work from the specified IP addresses.",
  "settings_apikeys_allowed_ips_label": "Allowed IP addresses",
  "settings_apikeys_ip_placeholder": "Enter IP address (e.g., 8.8.8.8)",
  "settings_apikeys_add_ip": "Add IP address",
  "settings_apikeys_remove_ip": "Remove IP address",
  "settings_apikeys_ip_required": "IP address is required",
  "settings_apikeys_ip_invalid": "Please enter a valid IP address",
  "settings_apikeys_allowed_ips": "Allowed IPs:",
  "settings_apikeys_permissions_label": "API Permissions",
  "settings_apikeys_permissions_description": "Choose which services this API Key can access.",
  "settings_apikeys_permission_send_smtp": "SMTP Sending",
  "settings_apikeys_permission_send_api": "HTTP API Sending",
  "settings_apikeys_permission_apis": "Statistics & Management APIs",
  "settings_apikeys_permissions_required": "Please select at least one option",
  "settings_apikeys_legacy_key_alert_message": "We've updated our <strong>SMTP authentication</strong> to use <strong>API keys</strong> instead of your account password.<br>To ensure a smooth transition, <strong>we've created a special API key</strong> for you that matches your old credentials. For improved security, we highly recommend you <strong>delete this key and create a new one</strong> to use in your SMTP settings.",
  "settings_apikeys_legacy_key_alert_link": "More info",
  "settings_apikeys_legacy_key_alert_link_href": "https://serversmtp.com/security-update-transition-to-api-key-authentication/",
  "settings_apikeys_legacy_name": "Auto-generated",
  "settings_apikeys_apikey_legacy_tooltip": "Auto-generated key: uses your dashboard email and password. For security, switch to a custom API key soon.",
  "settings_bccs_missing_required": "Please ensure to set one BCC as default before enabled it",
  "settings_bccs_notifications_default": "BCC default email updated successfully",
  "settings_link_branding_enable": "Enable to use your own tracking domains",
  "settings_link_branding_missing_required": "Add and verify at least one domain before activate",
  "settings_link_branding_title": "Custom Tracking Domains",
  "settings_link_branding_description": "Use your own domains for open and click tracking instead of turboSMTP ones.",
  "settings_link_branding_box_alert": "These settings won't take effect if Open Tracking and Click Tracking are disabled.",
  "settings_link_branding_empty_description": "Click \"Add Domain\" and complete the fields with the required information...",
  "settings_link_branding_empty_title": "Add Tracking Domain",
  "settings_link_branding_add_domain": "Add Tracking Domain",
  "settings_link_branding_add_domain_info": "Enter your domain and edit any additional settings.",
  "settings_link_branding_advanced": "Advanced options",
  "settings_link_branding_custom_subdomain": "Custom subdomain",
  "settings_link_branding_custom_subdomain_tooltip": "Please enter a valid domain name before specifying a custom subdomain",
  "settings_link_branding_custom_subdomain_info": "The system will generate a random subdomain. If you want to use a specific one, enter it here.",
  "settings_link_branding_button_add": "Add Tracking Domain",
  "settings_link_branding_match": "Match tracking domain with sender domain",
  "settings_link_branding_match_sender_disabled": "Matching domains disabled",
  "settings_link_branding_match_sender_enabled": "Matching domains enabled",
  "settings_link_branding_filters_no_results": "No entries were found with these filters",
  "settings_link_branding_search_placeholder": "Filter tracking domains by name...",
  "settings_link_branding_verification_placeholder": "Verification Status...",
  "settings_link_branding_verified": "Verified",
  "settings_link_branding_click_to_verify": "PENDING. The CNAME configuration for this domain has not been completed or verified. Click to proceed...",
  "settings_link_branding_verification_success": "Verification success",
  "settings_link_branding_verification_domain_not_found": "Domain not found",
  "settings_link_branding_verification_cname_not_found": "The {track_dns} subdomain CNAME is not found",
  "settings_link_branding_verification_auth_cname_not_found": "The {auth_dns} subdomain CNAME is not found",
  "settings_link_branding_verification_multiple_cname_found": "Multiple CNAME records for the {track_dns} subdomain are found",
  "settings_link_branding_verification_auth_multiple_cname_found": "Multiple CNAME records for the {auth_dns} subdomain are found",
  "settings_link_branding_verification_incorrect_cname_target": "The CNAME of {track_dns} subdomain has an incorrect value",
  "settings_link_branding_verification_auth_incorrect_cname_target": "The CNAME of {auth_dns} subdomain has an incorrect value",
  "settings_link_branding_enabled": "Enabled",
  "settings_link_branding_disabled": "Disabled",
  "settings_link_branding_not_verified": "Pending",
  "settings_link_branding_name": "Domain name",
  "settings_link_branding_enabled_no": "Tracking domain disabled",
  "settings_link_branding_enabled_yes": "Tracking domain active",
  "settings_link_branding_default_enabled": "Tracking domain set as non dedicated",
  "settings_link_branding_default_disabled": "Tracking domain set as dedicated",
  "settings_link_branding_subdomain_name_invalid": "Subdomain is invalid",
  "settings_link_branding_domain_name_invalid": "Invalid domain name",
  "settings_link_branding_confirm_delete_label": "Delete tracking domain",
  "settings_link_branding_confirm_delete_text": "Do you really want to delete this tracking domain?",
  "invalid_domain_name": "Invalid domain name provided",
  "settings_link_branding_exclusivity_placeholder": "Is dedicated...",
  "settings_link_branding_exclusive": "Dedicated",
  "settings_link_branding_not_exclusive": "Not dedicated",
  "settings_link_branding_domain_name": "Tracking Domain",
  "settings_link_branding_domain_status": "Status",
  "settings_link_branding_added": "Domain added successfully",
  "settings_link_branding_removed": "Domain removed successfully",
  "settings_link_branding_default_match_help": "Dedicated domains are only used with a matching sender domain. They are never used with unmatching sender domains",
  "settings_link_branding_dns_info": "You will need to install the following records to complete the process.",
  "settings_link_branding_ssl_verify": "We cannot check if your SSL domains are set up correctly from the dashboard. If you need help, please get in touch with our technical support team.",
  "settings_link_branding_dns_wait": "It may take up to 24 hours for changes to DNS records to take effect",
  "settings_link_branding_dns_info_host": "Add these two records to your host's DNS section.",
  "settings_link_branding_dns_type": "Type",
  "settings_link_branding_dns_host": "Host",
  "settings_link_branding_dns_host_help": "Some DNS hosting may refer to this as \"Domain\" or \"Name\"",
  "settings_link_branding_dns_value": "Value",
  "settings_link_branding_dns_value_help": "Some DNS hosting may refer to this as \"Data\"",
  "settings_link_branding_dns_help": "Not sure how to do this?",
  "settings_link_branding_dns_help_link": "Consult the documentation",
  "settings_link_branding_dns_verification_tooltip": "This CNAME record is the same for all subdomains of the domain. It should be added only once: if already present, you don't need to add it",
  "settings_link_branding_verify_description": "Once added, press Verify.",
  "settings_link_branding_verify_button": "Verify",
  "settings_link_branding_delete_info": "Don't need this tracking domain any more?",
  "settings_link_branding_delete_button": "Delete tracking domain",
  "settings_link_branding_security_placeholder": "Security...",
  "settings_link_branding_https": "HTTPS",
  "settings_link_branding_http": "HTTP",
  "settings_link_branding_button_ok": "Ok",
  "settings_link_branding_status_placeholder": "Status...",
  "settings_link_branding_status_enabled_no": "Disabled",
  "settings_link_branding_status_enabled_yes": "Active",
  "settings_link_branding_all_domains_disabled": "When all custom domains are disabled or pending, turboSMTP tracking links will be used.",
  "settings_link_branding_no_default_domain": "If you make all Active tracking links Dedicated, senders with disabled or missing domains on this list will use our turboSMTP tracking links instead.",
  "settings_link_branding_match_modal_cancel": "Cancel",
  "settings_link_branding_match_modal_confirm": "Ok",
  "settings_link_branding_match_title": "Domain Rotation",
  "settings_link_branding_match_change": "Change this behaviour",
  "settings_link_branding_match_enabled_title": "Match sender domain",
  "settings_link_branding_match_disabled_title": "Do not match sender domain",
  "settings_link_branding_match_enabled_info": "If the sender domain matches one of the active tracking domains, that tracking domain will be used.<br> If the domain of the sender doesn't match any tracking domain, one of the active tracking domains (excluding \"Dedicated\" ones) will be randomly used.",
  "settings_link_branding_match_disabled_info": "All active tracking domains will be used, despite the sender domain.",
  "settings_link_branding_limit_reached": "Almost there! You've hit the maximum number of custom tracking domains for your current plan. Contact support to explore upgrade options and keep growing!",
  "settings_link_branding_upgrade_button": "Upgrade now",
  "config_server_error": "Dashboard maintenance is underway, please retry in a few minutes",
  "feature_not_available_for_active_plan": "This feature is not available for any of your active plans",
  "forgot_password_use_different_password": "Please create a new password that is different from your previous passwords to enhance the security of your account.",
  "m_getting_started": "Getting started",
  "settings_sender_title": "Sender Domains Verification",
  "settings_sender_add_domain": "Add Domain",
  "settings_sender_description": "To improve your email delivery, simply authenticate your sender domains with few key DNS records.",
  "settings_sender_domains_empty": "There are no verified sender domains yet.<br>Please verify your first domain.",
  "settings_sender_if_unverified": "What if sender domain is not verified?",
  "settings_sender_notify_label": "Notify me by email if the sender domain is not verified",
  "settings_sender_notify_email_label": "Email address",
  "settings_sender_notify_email_tip": "If empty, the notification email will be sent to turboSMTP account address.",
  "settings_sender_notify_email_error": "Please enter a valid email address",
  "settings_sender_notify_email_placeholder": "Enter an email address...",
  "settings_sender_dns_title": "How to verify your domain",
  "settings_sender_dns_description": "For our SMTP service, you need to set up SPF and DKIM records for your sender domains. Adding a DMARC record is also mandatory for better email security and deliverability.",
  "settings_sender_spf_title": "SPF record",
  "settings_sender_spf_description": "Please proceed by appending the specified TXT record to the sender domain, choosing from one of the following two alternatives:",
  "settings_sender_dkim_title": "DKIM record",
  "settings_sender_dkim_description": "For DKIM, add the provided TXT record to your domain's DNS settings, which contains the public key used to verify that the emails sent from your domain are indeed legitimate and have not been tampered with during transit.",
  "settings_sender_dmarc_title": "DMARC record",
  "settings_sender_dmarc_description": "Complete the email authentication process by adding the given DMARC TXT record to your DNS, establishing a policy for how email receivers should treat messages that don't pass SPF or DKIM checks, and thus providing an additional layer of defense against fraudulent email practices.",
  "settings_sender_domain_added": "Sender domain <strong>{domain}</strong> added.",
  "settings_sender_domain": "Sender domain",
  "settings_sender_domains_name": "Domain name",
  "settings_sender_domains_action": "",
  "settings_sender_domains_action_verify": "Verify",
  "settings_sender_domains_action_delete": "Delete",
  "settings_sender_domains_action_subaccount": "Sub Account:",
  "settings_sender_action_delete_confirm_title": "Delete domain",
  "settings_sender_action_delete_confirm_message": "Are you sure you want to delete <strong>{domainName}</strong> domain?",
  "settings_sender_domain_description": "Specify the domain of the sender that you wish to validate:",
  "settings_sender_verify_record": "TXT record",
  "settings_sender_verify_value": "Status",
  "settings_sender_verify_ok": "Ok",
  "settings_sender_dns_ask_admin": "Please reach out to your account manager to verify the domain. This action is required and can only be performed by the primary account holder.",
  "settings_sender_verify_fail": "{type} not found or not properly configured",
  "settings_sender_verified": "Your domain is properly configured. You can safely send using this sender.",
  "settings_sender_dkim_domain_title": "DKIM domain",
  "settings_sender_dkim_value_title": "DKIM value",
  "settings_sender_dmarc_domain_title": "DMARC domain",
  "settings_sender_dmarc_value_title": "DMARC value",
  "settings_sender_domains_search_placeholder": "Filter sender domains by name...",
  "settings_sender_domains_status_placeholder": "Verification Status...",
  "settings_sender_domains_status_verified": "Verified",
  "settings_sender_domains_status_not_verified": "Not verified",
  "settings_sender_domains_filters_no_results": "No entries were found with these filters",
  "block_unverified_sender_title": "Block unverified sender domains",
  "block_unverified_sender_modal_title": "Unverified sender domains",
  "block_unverified_sender_desc": "If the sender domain is not verify, block email sending and notify me by email",
  "block_unverified_sender_change": "Change this behavior",
  "forward_as_received_title": "Send Without Modifications",
  "forward_as_received_info": "Send your emails without modifications, even from unverified sender domains. Be aware that this will likely result in a <strong>high bounce rate and low deliverability</strong> as your emails could be flagged as spam, affecting your domain's reputation.",
  "block_title": "Reject & Drop",
  "block_info": "Choose this option to ensure emails from unverified sender domains are not sent. Messages that fail SPF, DKIM, or DMARC checks will be automatically dropped to <strong>maintain your sending reputation</strong> and prevent the risk of being marked as spam.",
  "fallback_to_turbo_title": "Re-envelope Sender",
  "fallback_to_turbo_info": "Opt for re-enveloping to use a turboSMTP address as the sender for emails from unverified sender domains. This can improve deliverability, though the change in <strong>sender address might be noticed</strong> by recipients in their email clients.",
  "notification_email_updated": "Notification email has been updated.",
  "notification_email_enabled": "Notification email enabled.",
  "notification_email_disabled": "Notification email disabled.",
  "invalid_notification_email": "Invalid notification email provided.",
  "settings_sender_domains_new_intro": "Enter the new domain information.",
  "paginator_page": "Page",
  "paginator_of": "of",
  "no_records_found": "DNS record not found. Ensure that the record is published correctly and propagation has completed.",
  "invalid_record_found": "A DNS record was found but appears to be incorrectly formatted or has an invalid value.",
  "too_many_dns_lookups": "The SPF record includes more than the allowed limit of 10 DNS lookups, which can cause email delivery issues.",
  "more_than_spf_entry_found": "Multiple SPF records were detected for your domain. Only a single SPF record is permissible per domain.",
  "settings_sender_loading_domain_data": "Loading domain verification results...",
  "notice": "Notice",
  "settings_sender_domains_no_option": "<p>Your account currently operates under the \"Standard mode\", an <strong>older configuration</strong> that re-envelops all outgoing emails with our email address, regardless of your SPF, DKIM, and DMARC settings.</p><p>To enhance email deliverability, we strongly recommend choosing one of the updated fallback options available.</p>",
  "failed_to_get_a_aaaa_record": "Failed to get A / AAAA records for {domain_name}",
  "invalid_spf_syntax": "Invalid SPF syntax",
  "spf_has_upper_case_letters": "The SPF record must not contain capital letters. Please ensure all characters are lowercase to comply with the SPF specification.",
  "recursive_include_detected ": "Your SPF record should not include the domain itself as this creates a loop, leading to infinite DNS lookups. Please revise the SPF entry to remove the domain reference to avoid circular dependencies and comply with the SPF specification..",
  "spf_longer_than_255_characters": "SPF record exceeds the 255-character limit for a single DNS text string. To adhere to DNS specifications, please split your SPF record into multiple strings, each not exceeding 255 characters, or shorten the record to comply with the limit.",
  "ptr_mechanism_not_allowed": "To optimize SPF performance and promote the adoption of robust sender verification practices, it's advisable to exclude the \"ptr:\" mechanism and instead rely on mechanisms such as \"ip4:\" and \"include:\".",
  "data_location_modal_title": "Data Location",
  "data_location_network_servers": "Network Servers",
  "data_location_ip_location": "IP Location",
  "data_location_company_managing_data": "Company Managing Data",
  "data_location_network_servers_value": "Milan (IT), Frankfurt (DE), Amsterdam (NL)",
  "data_location_ip_location_value": "Europe RI.PE",
  "data_location_company_managing_data_value": "Edisplay Srl, Italy EU",
  "data_location_no_transfer_outside_eu": "No data is transferred outside the European Union",
  "gdpr_data_location": "All data in EU",
  "gdpr_see_details": "See details",
  "not_included_in_plan": "Not included in your current plan",
  "registration_logout": "Logout",
  "registration_step_personal": "Personal Info",
  "registration_step_company": "Company Info",
  "registration_step_address": "Address Info",
  "registration_label_email": "Email",
  "registration_label_firstname": "First Name",
  "registration_label_lastname": "Last Name",
  "registration_label_company": "Company",
  "registration_label_vat": "VAT Number",
  "registration_label_vat_optional": "(Optional)",
  "registration_label_phone": "Phone Number",
  "registration_label_website": "Website",
  "registration_label_website_hint": "(Optional)",
  "registration_label_address": "Address",
  "registration_label_city": "City",
  "registration_label_country": "Country",
  "registration_placeholder_country": "Select Country",
  "registration_label_region": "State / Region",
  "registration_placeholder_region": "Select Region",
  "registration_label_zip": "Zip Code",
  "registration_btn_back": "Back",
  "registration_btn_next": "Next Step",
  "registration_btn_complete": "Complete Profile",
  "registration_error_firstname": "First Name is required.",
  "registration_error_lastname": "Last Name is required.",
  "registration_error_company": "Company is required.",
  "registration_error_phone": "Phone Number is required.",
  "registration_error_website": "Please enter a valid URL.",
  "registration_error_address": "Address is required.",
  "registration_error_city": "City is required.",
  "registration_error_country": "Country is required.",
  "registration_error_region": "Region is required.",
  "registration_error_zip": "Zip Code is required.",
  "registration_error_phone_format": "Phone Number must contain only numbers.",
  "registration_address_message": "By ensuring your postal address is accurate, you can benefit from an <strong>expedited activation experience</strong>.",
  "registration_step_confirmation": "Confirmation",
  "registration_confirmation_title": "Profile Completed!",
  "registration_confirmation_message": "Your account has been successfully created.<br>You can now purchase a plan to unlock advanced features and higher sending limits",
  "registration_confirmation_message_buy": "Your account has been successfully created.",
  "registration_btn_buy_plan": "Buy a Plan",
  "registration_stay_free": "Stay free, you can upgrade later",
  "registration_btn_dashboard": "Go to Dashboard",
  "registration_redirect_to_shop": "You will be redirected to the checkout process in a moment...",
  "registration_go_to_shop": "Click here to proceed to checkout",
  "button_yes_delete": "Yes, delete",
  "button_yes_revoke": "Yes, revoke"
}
